/* Premium Lesson Planning API */
export default ($http) => ({
  getRecycledLessons(query) {
    return $http.get('premium-lesson/recycle', { query })
  },
  restoreRecycledLesson(id) {
    return $http.delete(`premium-lesson/recycle/${id}`)
  },
  updateAndRestoreRecycledLesson(id, payload) {
    return $http.put(`premium-lesson/${id}/update-and-restore`, { body: payload })
  },
  restoreRecycledLessons(payload) {
    return $http.delete('premium-lesson/recycle/bulk', { body: payload })
  },
  fetchTableData(query) {
    return $http.get('premium-lesson/browse', { query })
  },
  getUsers(query) {
    return $http.get('premium-lesson/users', { query })
  },
  addEditors (payload) {
    return $http.put('premium-lesson/bulk-teacher', { body: payload })
  },
  deleteEditors (payload) {
    return $http.delete('premium-lesson/bulk-teacher', { body: payload })
  },
  moveToRecycleBin (payload) {
    return $http.delete('premium-lesson/bulk', { body: payload })
  },
  fetchSettings() {
    return $http.get('premium-lesson/settings')
  },
  updateSettings(payload) {
    return $http.put('premium-lesson/settings', { body: payload })
  },
  markLessonAsApproveExample(id, action = undefined) {
    return $http.put(`premium-lesson/${id}/approved-example`, { body: { action } })
  },
  unmarkLessonAsApproveExample(id, action = undefined) {
    return $http.delete(`premium-lesson/${id}/approved-example`, { body: { action } })
  },
  markLessonsAsApproveExamples(payload) {
    return $http.put('premium-lesson/approved-examples/bulk', { body: payload })
  },
  unmarkLessonsAsApproveExamples(payload) {
    return $http.delete('premium-lesson/approved-examples/bulk', { body: payload })
  },
  markLessonsAsReviewed(payload) {
    return $http.put('premium-lesson/lessons-to-review/approve', { body: payload })
  }
})
